import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import toast from "react-hot-toast";
import { instalarAvisosEmTexto } from "@/utils/textoDoErro";

// Todo aviso vira TEXTO antes de chegar à tela (`utils/textoDoErro.js`): um `detail` em forma
// de objeto num `toast.error` derrubava a tela inteira.
instalarAvisosEmTexto(toast);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
